<template>

  <div id="header" class="align">
    <kari-logo-mobile class="logo" v-on:click="goToPath('/')"/>

    <nav class="navPC">
      <a v-on:click="scroll('howToUse')">Как пользоваться</a>
      <a v-on:click="scroll('questions')">Ответы на вопросы</a>
      <a href="tel:88001111111">8 800 700 90 21</a>
    </nav>

    <nav class="navMobile" v-if="mobileNav">
      <a v-on:click="scroll('howToUse')">Как пользоваться</a>
      <a v-on:click="scroll('questions')">Ответы на вопросы</a>
      <a href="tel:88001111111">8 800 700 90 21</a>
    </nav>

    <div class="navBtns PC" v-if="!isAuthenticated">
<!--      <button class="whiteButton" v-on:click="goTo('/registration')">-->
<!--        Регистрация-->
<!--      </button>-->
      <button class="purpleButton" v-on:click="goToPath('/login')">
        Войти
      </button>
    </div>

    <div class="PC" v-else v-on:click="menuFlag = !menuFlag">
      <div class="authorized">
        <avatar-icon class="avatar"/>
        <p>{{userDataState.name}} {{userDataState.lastName}}</p>
        <arrow-right class="arrow"/>
      </div>
    </div>

    <div class="mobile">
      <div class="authorized">
        <menu-icon-mobile v-on:click="menuFlag = false; mobileNav = true" v-if="!mobileNav"/>
        <cross-icon v-on:click="mobileNav = false" v-if="mobileNav"/>
        <avatar-mobile-icon v-on:click="menuFlag = true; mobileNav = false" v-if="!menuFlag"/>
        <cross-icon v-on:click="menuFlag = false" v-if="menuFlag"/>
      </div>
    </div>

    <div class="headerPopup" v-if="menuFlag">
      <div class="menuVar" v-if="isAuthenticated">
        <div class="menuPoint" v-on:click="goToPath('/lk/installments'); menuFlag = false">
          <chart-icon/>
          <p>Рассрочки</p>
        </div>
        <div class="menuPoint" v-on:click="goToPath('/lk/profile'); menuFlag = false">
          <smile-icon/>
          <p>Профиль</p>
        </div>
        <div class="menuPoint" v-on:click="goToPath('/lk/history'); menuFlag = false">
          <calendar-icon/>
          <p>История</p>
        </div>

        <div class="menuPoint" v-on:click="logOut(); menuFlag = false">
          <logout-icon/>
          <p>Выйти из профиля</p>
        </div>
      </div>
      <div class="menuVar" v-else>
        <div class="menuPoint" v-on:click="goToPath('/login'); menuFlag = false">
          <smile-icon/>
          <p>Вход</p>
        </div>
<!--        <div class="menuPoint" v-on:click="goTo('/registration'); menuFlag = false">-->
<!--          <smile-icon/>-->
<!--          <p>Регистрация</p>-->
<!--        </div>-->
      </div>
    </div>

  </div>
</template>

<script>
import AvatarIcon from '@/assets/svg/avatarIcon';
import { mapState, mapGetters } from 'vuex';
import KariLogoMobile from '@/assets/svg/kariLogoMobile';
import AvatarMobileIcon from '@/assets/svg/avatarMobileIcon';
import ArrowRight from '@/assets/svg/arrowRight';
import MenuIconMobile from '@/assets/svg/menuIconMobile';
import ChartIcon from '@/assets/svg/chartIcon';
import SmileIcon from '@/assets/svg/smileIcon';
import CalendarIcon from '@/assets/svg/calendarIcon'
import LogoutIcon from '@/assets/svg/logoutIcon';
import CrossIcon from '@/assets/svg/cross';
import { logOut } from '@/requests/kariRequests'
import { catchError } from '@/globalFunctions/functions'

export default {
  name: 'header-block',
  // components: { CrossIcon, LogoutIcon, CalendarIcon, SmileIcon, ChartIcon, MenuIconMobile, ArrowRight, AvatarMobileIcon, KariLogoMobile, AvatarIcon },
  components: { CrossIcon, LogoutIcon, SmileIcon, ChartIcon, MenuIconMobile, ArrowRight, AvatarMobileIcon, KariLogoMobile, AvatarIcon, CalendarIcon },
  data () {
    return {
      menuFlag: false,
      mobileNav: false
    };
  },
  methods: {
    goToPath (path) {
      this.$router.push(path);
    },
    scroll (value) {
      console.log(value);
      const id = document.getElementById(value);
      console.log(id);
      if (id) {
        id.scrollIntoView({ behavior: 'smooth' });
      } else {
        this.$router.push('/').then(() => { this.scroll(value) });
      }
    },
    async logOut () {
      this.$store.commit('showLoader', true);
      await logOut()
        .then((res) => {
          catchError(res).then(() => {
            this.$store.dispatch('clearLocalStorageAuth');
            this.$router.push('/');
            this.$store.commit('showLoader', false);
          }).catch(() => {
            this.$store.commit('showLoader', false);
          })
        })
    }
  },
  computed: {
    lkVar: {
      set (value) {
        this.$store.commit('setLkVar', value);
      }
    },
    ...mapState({
      loginVuex: state => state.auth.login,
      userDataState: state => state.user.user
    }),
    ...mapGetters([
      'isAuthenticated'
    ])
  }
};
</script>

<style scoped>
/*шапка*/
#header { display: flex; align-items: center; justify-content: space-between; position: relative; padding: 3.20vw 0 }
#header>.headerPopup {background: white; padding: 5.33vw 4.27vw; position: absolute; top: 15vw; left: -4.27vw; width: 100% ; z-index: 20; }
#header>.headerPopup>.menuVar>.menuPoint { display: flex; margin-bottom: 4.27vw; align-items: center; cursor: pointer}
#header>.headerPopup>.menuVar>.menuPoint>svg { margin-right: 1.33vw; width: 6.40vw; height: 6.67vw }
#header>.headerPopup>.menuVar>.menuPoint:last-child { border-top: 1px solid rgba(207, 207, 207, 1); margin-bottom: 0; padding-top: 4.27vw; color: rgba(87, 87, 87, 1) }
#header>.navMobile { position: absolute; background: white; display: flex; flex-direction: column; top: 15vw; left: -4.27vw; width: 100%; padding: 5.33vw 4.27vw; z-index: 10 }
#header>.navMobile>a { margin-bottom: 4.27vw; text-decoration-line: none; color: rgba(0, 0, 0, 1); font-size: 4.80vw }
#header>.navMobile>a:last-child { border-top: 1px solid rgba(207, 207, 207, 1); margin-bottom: 0; padding-top: 4.27vw; color: rgba(87, 87, 87, 1) }
#header>.navPC { display: none }
#header .authorized { display: flex; width: 20.27vw; justify-content: space-between }
#header .authorized>svg { width: 8.53vw; height: 8.53vw }
#header>.logo { cursor: pointer; width: 60vw; height: 8.27vw; margin-right: 25.60vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #header { padding: 56px 0 }
  #header>.headerPopup>.menuVar>.menuPoint { margin-bottom: 16px }
  #header>.headerPopup>.menuVar>.menuPoint>svg { width: 24px; height: 25px }
  #header>.headerPopup>.menuVar>.menuPoint:last-child { padding-top: 16px }
  #header .authorized { display: flex; width: 212px; justify-content: space-between; align-items: center; cursor: pointer }
  #header .authorized>.avatar { width: 32px; height: 32px }
  #header .authorized>.arrow { width: 6px; height: 12px }
  #header>.headerPopup { top: 117px; left: 953px; width: 205px; padding: 16px 12px 16px 12px; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25); border-radius: 4px }
  #header>.navMobile { display: none }
  #header>.navPC { display: flex; width: 601px; justify-content: space-between }
  #header>.navPC>a { text-decoration-line: none; font-size: 18px; color: rgba(0, 0, 0, 1)}
  #header .purpleButton {  width: 70px; padding: 11px 0 }
  #header .whiteButton {  width: 127px; margin-right: 8px; padding: 11px 0 }
  #header>.logo { cursor: pointer; width: 225px; height: 42px; margin-right: 40px }
  #header>.navBtns { display: flex; justify-content: space-between }
  #header>.navBtns>button {}
}
</style>
